export default "__VITE_ASSET__B8tMtj_0__"